<template>
  <div class="page-class page-center">
    <div class="page-staff-form">
      <h1 class="page-title text-center">{{ title }}</h1>
      <event-form-box
        list-url="/event-plan"
        :id="id"
        event-type="event"
        :form-type="formType"
        @add="onAdd"
        @edit="onEdit"
      >
      </event-form-box>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import router from '@/router';
import EventFormBox from '../../components/EventFormBox.vue';

export default {
  name: 'EventForm',
  components: {
    EventFormBox
  },
  async mounted() {
    if (this.$route.name === 'event-plan-new') {
      this.formType = 'new';
      this.id = null;
    } else {
      this.formType = 'update';
      this.id = this.$route.params.id;

      await this.getOne({
        type: 'event',
        id: this.id,
        router
      });
    }
  },
  data() {
    return {
      formType: '',
      id: null
    };
  },
  computed: {
    title() {
      return this.formType === 'new' ? 'Add New Event' : 'Update Event';
    },
    ...mapState('events', ['loading'])
  },
  methods: {
    ...mapActions('events', ['getOne', 'postOne', 'patchOne']),
    onAdd({ event }) {
      this.postOne({
        event,
        router,
        redirectUrl: '/eventplanlist'
      });
    },
    onEdit({ event }) {
      this.patchOne({
        type: 'event',
        id: this.id,
        event,
        router,
        redirectUrl: '/eventplanlist'
      });
    }
  }
};
</script>
